// extracted by mini-css-extract-plugin
export var editButton = "_p1-0";